import script from "./ppf.vue?vue&type=script&setup=true&lang=js"
export * from "./ppf.vue?vue&type=script&setup=true&lang=js"

import "./ppf.vue?vue&type=style&index=0&id=a7e4c7dc&scoped=true&lang=css"
import "./ppf.vue?vue&type=style&index=1&id=a7e4c7dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7e4c7dc"]])

export default __exports__